import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

// Chat del asistente de ventas (sales_agent/ en el servidor, publicado por nginx en /asistente/).
// El modelo corre en otro equipo: si no responde, queda el botón de WhatsApp de siempre.
const BASE = '/asistente';
const WHATSAPP = '573021124424';

const cargarWidget = () =>
  new Promise((resolve, reject) => {
    if (window.SalesAgentWidget) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = `${BASE}/static/widget.js`;
    script.dataset.title = 'Tablero Infinito';
    script.dataset.color = '#7C3AED';
    script.dataset.theme = 'dark';
    script.dataset.whatsapp = WHATSAPP;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });

const AsistenteChat = () => {
  const { pathname } = useLocation();
  const [estado, setEstado] = useState('cargando'); // cargando | chat | whatsapp
  const enAdmin = pathname.startsWith('/admin');

  useEffect(() => {
    let vigente = true;
    fetch(`${BASE}/api/chat/status`)
      .then((r) => (r.ok ? r.json() : { ok: false }))
      .then((data) => (data.ok ? cargarWidget() : Promise.reject()))
      .then(() => vigente && setEstado('chat'))
      .catch(() => vigente && setEstado('whatsapp'));
    return () => {
      vigente = false;
    };
  }, []);

  // El chat no se muestra en el panel de administración.
  useEffect(() => {
    if (estado !== 'chat') return;
    if (enAdmin) window.SalesAgentWidget?.hide();
    else window.SalesAgentWidget?.show();
  }, [estado, enAdmin]);

  return estado === 'whatsapp' ? <WhatsAppButton /> : null;
};

export default AsistenteChat;
